// extracted by mini-css-extract-plugin
export default {"Checkbox":"checkbox_Checkbox__9OFLh","Image":"checkbox_Image__O6z8+"};